export function round(number, precision) {
    var multiplier = !!precision ? Math.pow(10, precision) : 1;
    return Math.round(number * multiplier) / multiplier;
}
//# sourceMappingURL=round.js.map